import { Box, Container } from "@chakra-ui/react"
import { Headline } from "@/-components/Headline"
import { AnimatedScrollSection } from "@/-components/AnimatedScrollSection"
import { data } from "./_data"

export const GeneratorSteps = () => {
    return (
        <Box py={{ base: 0, lg: 12 }} px={{ base: 6, lg: 0 }}>
            <Box
                as="section"
                w="full"
                mx="auto"
                align="center"
                mt={12}
            >
                <Container w="full" maxW="7xl" mb={{ base: 0, lg: 24, '2xl': 0 }}>
                    <Headline
                        heading="Generating a visual sitemap"
                        subheading="Our free visual sitemap generator and website crawler is intuitive and easy to use, but if you need a helping hand, follow the steps below to get started."
                        textAlign="center"
                        mx="auto"
                        mb={{ base: 6, lg: 24, '2xl': 0 }}
                    />
                    <AnimatedScrollSection data={data} />
                </Container>
            </Box>
        </Box>
    )
}